import * as React from "react";
import * as PropertiesSelector from "../../../../properties-selector";
import * as LanguageTexts from "@genesys/shared/lib/language-texts";
import * as InfiltrationModelSettings from "../../../tools/moisture-load-rules/infiltration-model-settings";
import { infiltrationModelSelectionsDef } from "../definitions";
import { createCustomRowRenderer } from "../ps-custom-row-renderer";
import { PropertyValueSet } from "@genesys/property";
import { StyledH3 } from "../local-elements";
import { InternalProps } from "../types";

export function InfiltrationModelSelections(props: InternalProps) {
  const {
    sharedState,
    propertySelectorState,
    propertyDefinitions,
    renderPropertySelector,
    renderSystemOverride
  } = props;

  const currentSelections = PropertiesSelector.getSelectedProperties(
    propertySelectorState
  )!;
  const manualInputKey = InfiltrationModelSettings.manualInputProperty;

  const infiltrationModelManualInputEnabled = !!(
    manualInputKey &&
    PropertyValueSet.getInteger(manualInputKey, currentSelections)
  );
  const def = infiltrationModelSelectionsDef(
    infiltrationModelManualInputEnabled,
    propertyDefinitions
  );

  const systemOverride = infiltrationModelManualInputEnabled
    ? renderSystemOverride(
        InfiltrationModelSettings.overridableProperties,
        "MoistureLoadTool.SystemConfiguration"
      )
    : null;

  return (
    <div>
      <StyledH3>
        {sharedState.translate(
          LanguageTexts.globalPropertyName("mlcinfiltrationmodel")
        )}
      </StyledH3>
      {renderPropertySelector(
        def,
        createCustomRowRenderer(manualInputKey, systemOverride),
        "MoistureLoadTool.SystemConfiguration"
      )}
    </div>
  );
}
